/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiProspectAddCallDetailsDto,
  ApiProspectOrganisationDetailsUpdateDto,
  ApplicationInfoDto,
  ConfirmProspectEmailDto,
  ProspectDto,
  UserDetailsDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProspectController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags prospect-controller
   * @name PricingPlanSelected
   * @request PUT:/api/v1/prospects/pricing-plan
   */
  pricingPlanSelected = (params: RequestParams = {}) =>
    this.http.request<ProspectDto, any>({
      path: `/v1/prospects/pricing-plan`,
      method: 'PUT',
      format: 'json',
      ...params,
    })

  static pricingPlanSelectedPath = '/v1/prospects/pricing-plan'
  static pricingPlanSelectedMethod = 'PUT'
  /**
   * No description
   *
   * @tags prospect-controller
   * @name UpdateOrganisationDetails
   * @request PUT:/api/v1/prospects/organisation-details
   */
  updateOrganisationDetails = (
    data: ApiProspectOrganisationDetailsUpdateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ProspectDto, any>({
      path: `/v1/prospects/organisation-details`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationDetailsPath = '/v1/prospects/organisation-details'
  static updateOrganisationDetailsMethod = 'PUT'
  /**
   * No description
   *
   * @tags prospect-controller
   * @name SelectCustomPricingPlan
   * @request PUT:/api/v1/prospects/custom-pricing-plan
   */
  selectCustomPricingPlan = (data: ApiProspectAddCallDetailsDto, params: RequestParams = {}) =>
    this.http.request<ProspectDto, any>({
      path: `/v1/prospects/custom-pricing-plan`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static selectCustomPricingPlanPath = '/v1/prospects/custom-pricing-plan'
  static selectCustomPricingPlanMethod = 'PUT'
  /**
   * No description
   *
   * @tags prospect-controller
   * @name ConfirmEmail
   * @request POST:/api/v1/prospects/{prospectId}/email-confirmation
   */
  confirmEmail = (prospectId: string, data: ConfirmProspectEmailDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/prospects/${prospectId}/email-confirmation`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static confirmEmailPath = '/v1/prospects/${prospectId}/email-confirmation'
  static confirmEmailMethod = 'POST'
  /**
   * No description
   *
   * @tags prospect-controller
   * @name AddCallDetails
   * @request POST:/api/v1/prospects/call-details
   */
  addCallDetails = (data: ApiProspectAddCallDetailsDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/prospects/call-details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static addCallDetailsPath = '/v1/prospects/call-details'
  static addCallDetailsMethod = 'POST'
  /**
   * No description
   *
   * @tags prospect-controller
   * @name CreateApplication
   * @request POST:/api/v1/prospects/application
   */
  createApplication = (params: RequestParams = {}) =>
    this.http.request<ApplicationInfoDto, any>({
      path: `/v1/prospects/application`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static createApplicationPath = '/v1/prospects/application'
  static createApplicationMethod = 'POST'
  /**
   * No description
   *
   * @tags prospect-controller
   * @name FindByUserId
   * @request GET:/api/v1/prospects
   */
  findByUserId = (params: RequestParams = {}) =>
    this.http.request<ProspectDto, any>({
      path: `/v1/prospects`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findByUserIdPath = '/v1/prospects'
  static findByUserIdMethod = 'GET'
  /**
   * No description
   *
   * @tags prospect-controller
   * @name GetUserDetails
   * @request GET:/api/v1/prospects/user-details
   */
  getUserDetails = (params: RequestParams = {}) =>
    this.http.request<UserDetailsDto, any>({
      path: `/v1/prospects/user-details`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getUserDetailsPath = '/v1/prospects/user-details'
  static getUserDetailsMethod = 'GET'
  /**
   * No description
   *
   * @tags prospect-controller
   * @name GetProspectsLegalForms
   * @request GET:/api/v1/prospects/legal-forms
   */
  getProspectsLegalForms = (params: RequestParams = {}) =>
    this.http.request<
      (
        | 'PRIVATE_LIMITED_COMPANY'
        | 'PUBLIC_LIMITED_COMPANY'
        | 'GENERAL_PARTNERSHIP'
        | 'LIMITED_PARTNERSHIP'
        | 'ASSOCIATION'
        | 'SOLE_TRADER'
      )[],
      any
    >({
      path: `/v1/prospects/legal-forms`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getProspectsLegalFormsPath = '/v1/prospects/legal-forms'
  static getProspectsLegalFormsMethod = 'GET'
}
